import { useContext } from "react";
import { NotificationsContext } from "../providers/NotificationsProvider";

export function useNotifications() {
  const { addNotifications, notifications } = useContext(NotificationsContext);

  return { addNotifications, notifications };
}
